import { Outlet, useLocation, useNavigate } from 'react-router-dom'

import SideBar from '../components/common/sidebar'
import UserProfile from '../components/common/user-profile'
import { useDashboardContext } from '../providers/contexts/Dashboard'
import { ROUTES } from '../utils/constants/enum'
import { getUserNav } from '../utils/helper-functions'
import AccountFooter from './AccountFooter'
import AccountHeader from './AccountHeader'

import { useEffect } from 'react'
import { MLOptIn } from '../components/dashboard/rewards/modal/mLOptIn'
import { OptIn } from '../components/dashboard/rewards/modal/opt-in'
import { OptInStatusModal } from '../components/dashboard/rewards/modal/optInStatusModal'
import CountrySelectModal from '../components/modals/countrySelectModal'
import { UserRole } from '../utils/constants'
import './dashboardLayout.scss'

const DashboardLayout = () => {
    const {
        userData,
        setShowOptIn,
        showMLOptIn,
        setShowMLOptIn,
        showMLOptInStatus,
        setShowMLOptInStatus,
        showOptIn,
    } = useDashboardContext(
        ({
            userData,
            showMLOptIn,
            setShowOptIn,
            setShowMLOptIn,
            showMLOptInStatus,
            setShowMLOptInStatus,
            showOptIn,
        }) => ({
            userData,
            setShowOptIn,
            showMLOptIn,
            setShowMLOptIn,
            showMLOptInStatus,
            setShowMLOptInStatus,
            showOptIn,
        })
    )
    const { pathname } = useLocation()
    const NavItems = getUserNav(userData, '')
    const navigate = useNavigate()
    const isMultiAccount = userData?.multiAccount
    useEffect(() => {
        if (
            !userData?.loyaltyOptInB2B2C &&
            userData?.userRole === UserRole.Provider &&
            (userData.country === 'us' || userData?.country === 'ca') &&
            userData?.memberId
        ) {
            isMultiAccount ? setShowMLOptIn(true) : setShowOptIn(true)
        }
    }, [])

    return (
        <>
            <AccountHeader status={true} />
            {userData?.userRole && (
                <div className="dashboard">
                    <div className="dashboard-inner">
                        {pathname !== ROUTES.ACCOUNT_DELETE && <UserProfile />}
                        <div className={'dashboard-details'}>
                            <SideBar sidebarNav={NavItems} />
                            <Outlet />
                            <MLOptIn
                                open={showMLOptIn}
                                closeModal={() => {
                                    setShowMLOptIn(false)
                                }}
                            />
                            <OptInStatusModal
                                open={showMLOptInStatus}
                                closeModal={() => {
                                    setShowMLOptInStatus(false)
                                    navigate(ROUTES.CLIENT_REWARDS)
                                }}
                            />
                            <OptIn
                                open={showOptIn}
                                closeModal={() => setShowOptIn(false)}
                            />

                            {!Boolean(userData.country) ? (
                                <CountrySelectModal />
                            ) : null}
                        </div>
                    </div>
                </div>
            )}
            <AccountFooter status={true} />
        </>
    )
}
export default DashboardLayout
